import { render, staticRenderFns } from "./PermissionCards.vue?vue&type=template&id=1c56f21c&scoped=true"
import script from "./PermissionCards.vue?vue&type=script&lang=js"
export * from "./PermissionCards.vue?vue&type=script&lang=js"
import style0 from "./PermissionCards.vue?vue&type=style&index=0&id=1c56f21c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c56f21c",
  null
  
)

export default component.exports